import styled from 'styled-components';

export const SearchTitle = styled.h1`
  font-size: 16px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const DiscoverTopicSection = styled.div`
  @media (max-width: 720px) {
    padding: 6px 10px 0;
  }
`;
export const SearchTopics = styled.input`
  width: 100%;
  height: 42px;
  padding: 0 30px 0 38px;
  border: 1px solid hsl(0deg, 0%, 0%, 80%);
  outline: none;
  font-size: 14px;
  font-family: 'Montserrat';
  margin: 16px 0;
  border-radius: 2px;
`;

export const SearchSection = styled.div`
  position: relative;
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 12px;
  top: 29px;
  width: 16px;
  height: 16px;
`;
